@if (truncatedDocumentList().length > 0) {
    <section class="user-documents">
        @if (block.data.heading?.length > 1) {
            <h2 [innerText]="block.data.heading"></h2>
        }
        <div class="user-documents__list">
            @for (document of truncatedDocumentList(); track document.id) {
                <div class="user-document">
                    <img src="/assets/img/ui/download-small.svg" alt="" class="user-document__icon" />
                    <span class="user-document__content">
                        <h3 class="user-document__title">
                            <a
                                (click)="$event.preventDefault(); downloadDocument(document)"
                                href="#"
                                class="user-document__link">
                                <span class="visually-hidden">Download</span>
                                {{ document.name }}
                            </a>
                        </h3>
                        <p class="user-document__description">
                            Uploaded: <strong>{{ document.uploaded }}</strong>
                        </p>
                        <p class="user-document__description">
                            Type: <strong>{{ document.type }}</strong>
                        </p>
                        <button class="btn btn--small btn-secondary" (click)="downloadDocument(document)">
                            Download <span class="visually-hidden">{{ document.name }}</span>
                        </button>
                    </span>
                </div>
            }
        </div>

        @if (totalPages() > 1) {
            <nav class="user-documents__pagination" aria-label="Document pagination">
                <ul class="pagination">
                    <li class="page-item" [class.disabled]="currentDocPage() === 1">
                        <button
                            type="button"
                            class="page-link"
                            (click)="setPage(currentDocPage() - 1)"
                            aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                        </button>
                    </li>

                    @for (page of [].constructor(totalPages()); track $index) {
                        <li class="page-item" [class.active]="currentDocPage() === $index + 1">
                            <button type="button" class="page-link" (click)="setPage($index + 1)">
                                {{ $index + 1 }}
                            </button>
                        </li>
                    }

                    <li class="page-item" [class.disabled]="currentDocPage() === totalPages()">
                        <button
                            type="button"
                            class="page-link"
                            (click)="setPage(currentDocPage() + 1)"
                            aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </button>
                    </li>
                </ul>
            </nav>
        }
    </section>
}
